import React from 'react';
import Layout from '../components/Layout';
import Policy01 from '../components/Policy01';
import Policy02 from '../components/Policy02';

// Public pages (no login) so the store listings can link to them: /Terms, /Privacy
const Policy = ({ kind }) => (
  <Layout header={{ title: kind === 'privacy' ? '개인정보처리방침' : '이용약관', Backbtn: true, link: localStorage.getItem('token') ? '/Profile' : '/' }} containName='account'>
    {kind === 'privacy' ? <Policy02 /> : <Policy01 />}
  </Layout>
);

export default Policy;
